/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React, { useState } from 'react'
import Text from './Text'

const STORAGE_KEY = 'eggsconnect-onboarding-dismissed'

/**
 * Onboarding-Banner für die Gondel-Übersicht
 * Erklärt das Umadum-Konzept. Dismissbar mit localStorage-Persistenz.
 * @param {Object} props
 * @param {string} [props.className] - Zusätzliche CSS-Klassen
 */
export default function OnboardingBanner({ className = '' }) {
  const [visible, setVisible] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) !== 'true'
    } catch {
      return true
    }
  })
  const [dismissing, setDismissing] = useState(false)

  if (!visible) return null

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true')
    } catch {
      /* ignore — banner will reappear next visit */
    }
    setDismissing(true)
    setTimeout(() => setVisible(false), 300)
  }

  return (
    <div
      className={`relative bg-eggs-yellow rounded-xl p-4 mb-6 animate-fade-in transition-opacity duration-300 ${dismissing ? 'opacity-0' : 'opacity-100'} ${className}`}
      role="region"
      aria-label="Onboarding"
    >
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 w-12 h-12 flex items-center justify-center rounded-full hover:bg-black/10 transition-all duration-200"
        aria-label="Schließen"
      >
        <span aria-hidden="true" className="text-xl leading-none">✕</span>
      </button>
      <Text type="Heading" variant="h3" className="pr-10 mb-2">
        30 Minuten. Ein Experte. Dein Thema.
      </Text>
      <Text type="Body" variant="Base">
        Steig in eine Umadum-Gondel und triff einen Experten für ein
        persönliches Gespräch zu deinem Thema.
      </Text>
    </div>
  )
}
